import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { IOfflineText } from '../../../cashier-payments';
import { Experiment } from '../../../types/Experiment';
import { t } from '../../../utils/i18n';
import { IClientPaymentMethod } from '../types';
import { IPaymentMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';

const tryParseCustomOfflineText = (
  merchantInstructionsStr: string
): IOfflineText => {
  try {
    return JSON.parse(merchantInstructionsStr);
  } catch (error) {
    console.log(`Failed to parse custom offline text info`, error);
  }
};

const parseAdditionalInfo = (
  serverPMethod: IPaymentMethod,
  params: {
    manualPaymentDescription?: string;
  }
): IOfflineText | any => {
  switch (serverPMethod.paymentMethod) {
    case PaymentMethod.Offline: {
      let result: IOfflineText = {} as IOfflineText;
      const { merchantInstructions, ...leftover } =
        serverPMethod.additionalInfo || {};

      if (merchantInstructions) {
        result = tryParseCustomOfflineText(merchantInstructions) || result;
      }

      if (params.manualPaymentDescription) {
        result.text = params.manualPaymentDescription;
      }

      return {
        ...leftover,
        ...result,
      };
    }
    case PaymentMethod.CreditCard:
      return {
        ...serverPMethod.additionalInfo,
        installments: serverPMethod.installments,
      };
    default:
      return serverPMethod.additionalInfo;
  }
};

export const transformServerToClientPMethods = (
  serverPMethods: IPaymentMethod[] = [],
  params: {
    manualPaymentDescription?: string;
  }
): IClientPaymentMethod[] =>
  serverPMethods.map((serverPMethod) => {
    const paymentMethod = serverPMethod.paymentMethod as PaymentMethod;
    const additionalInfo = parseAdditionalInfo(serverPMethod, {
      manualPaymentDescription: params.manualPaymentDescription,
    });
    let methodTitle: string;

    if (
      serverPMethod.methodTitle &&
      (paymentMethod !== PaymentMethod.Offline ||
        experimentsService.isExperimentEnabled(
          Experiment.UseManualTitleFromMetadata
        ))
    ) {
      methodTitle = serverPMethod.methodTitle;
    } else {
      const getPMethodTitleKey = (): string => {
        switch (paymentMethod) {
          case PaymentMethod.Offline:
            return (
              additionalInfo?.titleId || 'settings.offlineTitleOptionDefault'
            );
          case PaymentMethod.InPerson:
            return 'settings.inPerson.title';
          case PaymentMethod.Sofort:
            return 'sofortKlarna';
          default:
            return paymentMethod;
        }
      };

      methodTitle = t(getPMethodTitleKey());
    }

    return {
      additionalInfo,
      label: methodTitle,
      icon: serverPMethod.methodIcon,
      connectedProviderId: serverPMethod.connectedProviderId as PaymentProvider,
      value: paymentMethod,
      mandatoryFields: serverPMethod.mandatoryFields,
      disabled: serverPMethod.disabled,
      frameable: serverPMethod.frameable,
      responsive: serverPMethod.responsive,
      redirectable: serverPMethod.redirectable,
      serverPMethod: { ...serverPMethod, methodTitle },
    };
  });
